import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Shimmer } from '../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Card } from '../../../CommonComponents/OPL/Card/Card';

export const LoadingPost = () => (
  <Card as="li" p="16" mb="16">
    <Box display="flex" justifyContent="space-between" mb="4">
      <Shimmer width={400} height={20} mb="4" />
      <Shimmer width={126} height={20} />
    </Box>
    <Box display="flex" alignItems="center" mb="16">
      <Shimmer width={146} height={20} mr="8" />
      <Shimmer width={60} height={20} />
    </Box>

    <Shimmer width="100%" height={20} mb="8" />
    <Shimmer width="100%" height={20} mb="8" />
    <Shimmer width="100%" height={20} mb="24" />
    <Box>
      <Shimmer width={212} height={22} />
    </Box>
  </Card>
);
